/**
 * Yardzen's overall review summary. Update the count here and every review
 * badge on the site follows (StarRating, Reviews, PDP, home comparison).
 */
export const YARDZEN_REVIEW_RATING = "4.8";
export const YARDZEN_REVIEW_COUNT = "19,699";
export const REVIEWS_PAGE_HREF = "/reviews";

// A site-wide count like "16,640 Reviews" or "19,699 reviews". Thousands
// separator required, so a single designer's "23 reviews" never matches.
const REVIEW_COUNT_PATTERN = /\d{1,3}(?:,\d{3})+\+?(?=\s*reviews\b)/i;

/** True when the text carries Yardzen's site-wide review count. */
export function hasYardzenReviewCount(text: string | undefined): boolean {
  return !!text && REVIEW_COUNT_PATTERN.test(text);
}

/** Swaps whatever count an editor typed for the current one. */
export function withCurrentReviewCount(text: string): string {
  return text.replace(
    new RegExp(REVIEW_COUNT_PATTERN, "gi"),
    YARDZEN_REVIEW_COUNT,
  );
}
